<p-blockUI [blocked]="loading" />
@if (!this._deviceService.isMobile()) {
  <div class="ui-g ui-fluid table-actions">
    <div class="ui-g-6 ui-xl-offset-8 ui-lg-offset-8" style="text-align: right">
      <div class="ui-g-1" style="text-align: right"></div>
      <div
        class="ui-g-4 ui-xl-4 ui-lg-5 button-wrapper ui-input-group"
        id="mocevent-action-buttons"
      >
        <div id="business-units-wrapper">
          <app-business-unit-filter
            (selectedBusinessUnitsChanged)="handleBusinessUnitChange()"
            #buFilter
          />
        </div>
        @if (canCreate === true) {
          <button
            pButton
            class="action-button"
            label="{{ 'COMMON.LABEL.BUTTONS.NEW' | translate }}"
            icon="fa fa-fw fa-plus-circle"
            (click)="newMocEvent()"
          ></button>
        }
        <button
          pButton
          class="action-button"
          label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
          icon="fa fa-fw fa-eraser"
          (click)="clearScreen()"
        ></button>
        <button
          pButton
          class="action-button-icon-only"
          icon="fa fa-fw fa-refresh"
          (click)="refresh()"
        ></button>
      </div>
    </div>
  </div>
}

@if (!this._deviceService.isMobile()) {
  <div class="table">
    <app-general-grid
      [values]="elements"
      [columns]="columns"
      [loading]="loading"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [filterable]="true"
      [screenName]="screenName"
      [lazy]="true"
      (lazyLoad)="lazyLoad($event)"
      [includeExportCSV]="false"
      (changeViewEvent)="changeViewEvent($event)"
      scrollHeight="calc(100vh - 256px)"
      [usePaginator]="true"
      [rowsPerPageOptions]="[10, 20, 50]"
      #grid
      [alwaysShowPaginator]="true"
    />
  </div>
}
